import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot, Params
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;

    //if(this.checkLogin()){
    // this.router.navigate(['/workspace']);
    //}

    return this.checkLogin(route);
  }

  private checkLogin(route: ActivatedRouteSnapshot): boolean {
    const queryParams = route.queryParams;

    if (this.authService.isLoggedIn()) {
      return true;
    } else if (this.authService.waitingConfirmation()) {
      this.router.navigate(['/confirmation'], { queryParams });
    } else {
      this.router.navigate(['/login'], { queryParams });
    }
  }
}

